export enum StorageProperties {
  ACCESS_TOKEN = 'mobile_access_token',
  REFRESH_TOKEN = 'mobile_refresh_token',
  EXPIRATION = 'mobile_expiration',
  USER_ID = 'mobile_user_id',
  GROUP = 'mobile_group',
  PLATFORM = 'mobile_platform',
  EMAIL = 'mobile_email',
}
